import React from 'react';
import PropTypes from 'prop-types';
import { HalfCircleSpinner as Loading } from 'react-epic-spinners';
var CordataLoading = function CordataLoading(props) {
  return React.createElement('div', {
    className: 'text-center py-3'
  }, React.createElement(Loading, props), React.createElement('h6', {
    className: 'font-italic text-primary'
  }, 'Loading ...'), props.message && React.createElement('p', null, props.message));
};
CordataLoading.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  message: PropTypes.string
};
CordataLoading.defaultProps = {
  color: '#007bff',
  className: 'mx-auto mb-3',
  message: undefined
};
export default CordataLoading;